import { useMemo } from 'react';
import Box from '@mui/material/Box';
import { Chip } from '@/atoms/Chip';
import { DataTable, type MRT_ColumnDef } from '@/organisms/Table';
import { TablePageLayout } from '@/templates/TablePageLayout';

/**
 * InventoryExample
 * Example asset inventory page built on TablePageLayout + DataTable.
 */
interface Asset {
  name: string;
  type: string;
  severity: 'critical' | 'high' | 'medium' | 'low';
  region: string;
}

const data: Asset[] = [
  { name: 'prod-db-01', type: 'RDS', severity: 'critical', region: 'us-east-1' },
  { name: 'eks-cluster', type: 'EKS', severity: 'high', region: 'eu-west-1' },
  { name: 's3-backups', type: 'S3', severity: 'medium', region: 'us-west-2' },
  { name: 'vpc-shared', type: 'VPC', severity: 'low', region: 'us-east-1' },
];

export function InventoryExample() {
  const columns = useMemo<MRT_ColumnDef<Asset>[]>(
    () => [
      { accessorKey: 'name', header: 'Asset' },
      { accessorKey: 'type', header: 'Type' },
      {
        accessorKey: 'severity',
        header: 'Severity',
        Cell: ({ cell }) => (
          <Chip purpose="severity" level={cell.getValue<Asset['severity']>()} size="small" />
        ),
      },
      { accessorKey: 'region', header: 'Region' },
    ],
    [],
  );
  return (
    <Box sx={{ p: 3 }}>
      <TablePageLayout title="Inventory" description="Cloud assets across all accounts.">
        <DataTable columns={columns} data={data} />
      </TablePageLayout>
    </Box>
  );
}
